<style lang="scss" scoped>
.slide-19 {
  background-image: url("../../../assets/module5/slide19/bg-05.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 40px;
  height: calc(100% - 40px);
}
h1 {
  font-size: 193px;
  color: #c5d43b;
  transform: rotate(-3deg);
  margin-top: 20px;
  text-align: center;
  line-height: 1;
}
.content {
  margin-left: 715px;
}
p {
  color: white;
  max-width: 600px;
  margin-top: 40px;
  margin-bottom: 100px;
}
.tim {
  z-index: 9;
}
h2 {
  color: white;
  font-size: 58px;
  &:first-of-type {
    color: #09509c;
    margin-bottom: 20px;
  }
}
.close {
  position: absolute;
  width: 100px;
  right: 10px;
  bottom: 10px;
}
a {
  color: white;
  text-decoration: none;
  font-size: 34px;
  margin-top: 33px;
  display: inline-block;
}
.download {
  display: block;
  transition: all 0.2s ease-out;
  cursor: pointer;
  width: 350px;
  height: auto;
  position: absolute;
  bottom: 200px;
  z-index: 9;
  &:hover {
    transform: scale(1.1);
  }
  img {
    width: 100%;
    height: auto;
  }
}
</style>

<template>
  <div class="slide-19">
    <transition name="fadeLeft" appear>
      <img
        v-if="slideIndex == 18"
        src="@/assets/module5/slide19/timmy-05.png"
        class="chars tim"
      />
    </transition>

    <transition name="fadeRight" appear>
      <img
        v-if="slideIndex == 18"
        src="@/assets/module5/slide19/images-05.png"
        class="chars"
      />
    </transition>

    <transition name="fadeUp" appear>
      <div v-if="slideIndex == 18" class="delay-2">
        <h1>Congratulations</h1>
      </div>
    </transition>

    <transition name="fadeUp" appear>
      <div class="content delay-3" v-if="slideIndex == 18">
        <p>
          Don’t forget to show your parents what you have learned, make sure you
          visit our website to check the FAST Heroes Leaderboard and really
          importantly, don’t forget to download and print your FAST Hero’s
          Certificate.
        </p>
        <h2>BYE FAST HEROES!</h2>
        <h2>
          DON’T FORGET
          <br />TOGETHER WE CAN SAVE THE <br />WORLD “ONE GRANDHERO AT A TIME!”
        </h2>
        <a href="https://fastheroes.com">www.fastheroes.com</a>
      </div>
    </transition>
    <img
      @click.prevent="reload()"
      class="close"
      src="@/assets/module1/slide27/button_close.png"
    />
    <a :href="imageFile" class="download" target="_blank">
      <img
        src="@/assets/module5/slide19/download_certificate_btn.svg"
        class="download"
      />
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageFile:
        window?.CF_EBOOK_VARS?.documents?.book_5_document_3?.url ||
        "../Website-Certificate-Fast_DEFAULT_107.png",
      imageId:
        window?.CF_EBOOK_VARS?.documents?.book_5_document_3?.document_id ||
        "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {
    reload() {
      window.location = "/e-books/";
    }
  }
};
</script>
